<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="kZGKeyParts"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editKZGComponent.open(0)">新建</el-button>
        <el-button type="danger" @click="deleteIds">批量删除</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="件号">
            <el-input v-model.trim="filter.partNo" clearable/>
          </vm-search>
          <vm-search label="名称">
            <el-input v-model.trim="filter.partName" clearable/>
          </vm-search>
          <vm-search label="客户名称">
            <el-input v-model.trim="filter.customer" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="partNo" align="center" label="件号"/>
      <el-table-column prop="wbpartNo" align="center" label="外部件号"/>
      <el-table-column prop="partName" align="center" label="名称"/>
      <el-table-column prop="customer" align="center" label="客户名称"/>
      <el-table-column prop="productionWorkLine" align="center" label="生产线"/>
      <el-table-column prop="productionWorkLineProcess" align="center" label="工序"/>
      <el-table-column prop="statusText" align="center" label="状态">
        <template slot-scope="scope">
          <span>
            {{scope.row.statusText === "启用" ? "启用":"禁用"}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="120px">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editKZGComponent.open(scope.row.pkid)">编辑</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <k-z-g-component-edit ref="editKZGComponent" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import KZGComponentEdit from "@/views/information/KZGComponent/KZGComponentEdit";
  export default {
    name: "KZGComponentList",
    components: {KZGComponentEdit,VmTable,VmSearch},
    data() {
      return {
        idList: "",
        filter: {
          partNo: "",
          partName: "",
          customer: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onNodeClick(data) {
        this.filter.keyWord = data.departmentName;
        this.getList(1);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      //批量删除
      deleteIds() {
        if(this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.pkid);
          }
          console.log(ids);
          this.$http
            .delete("basic","kZGKeyParts/idList",ids).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        }else{
          this.$message.error("请选择要删除的内容");
        }

      },
    },
  };
</script>

<style scoped>

</style>
